import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const UserDataSkeleton = () => (
  <div className="container-fluid p-3">
    <div className="row">
      <div className="col-12 mb-3">
        <div className="row ">
          <div className="col-4">
            <Skeleton width="100%" height={15} />
          </div>
        </div>
        <div className="row mb-3 d-flex justify-content-end">
          <div className="col-1" />
        </div>
        <div className="row mb-3">
          <div className="col-12">
            <Skeleton width="100%" height={50} />
          </div>
        </div>
        <div className="row  d-flex justify-content-end">
          <div className="col-1">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-1">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="col-1">
            <Skeleton width="100%" height={25} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default UserDataSkeleton;
